export default "__VITE_ASSET__6$WXQybn__"